import { render, staticRenderFns } from "./history_data.vue?vue&type=template&id=5701fc1d&"
import script from "./history_data.vue?vue&type=script&lang=js&"
export * from "./history_data.vue?vue&type=script&lang=js&"
import style0 from "./history_data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports